// UTC date formatting. Every time shown in the app is UTC and says so.
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
  'August', 'September', 'October', 'November', 'December'];

const parse = (iso) => {
  if (!iso) return null;
  // Backend timestamps are naive UTC (no zone): without a designator, append Z
  // so they are not read as local time.
  const s = String(iso);
  const d = new Date(/[zZ]|[+-]\d{2}:?\d{2}$/.test(s) ? s : `${s}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
};

const pad = (n) => String(n).padStart(2, '0');

/** `12 Oct 2026 UTC`, or `12 Oct 2026, 14:05 UTC` with time. '' when empty or invalid. */
export function formatDateUTC(iso, { withTime = false } = {}) {
  const d = parse(iso);
  if (!d) return '';
  const date = `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()].slice(0, 3)} ${d.getUTCFullYear()}`;
  return withTime ? `${date}, ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC` : `${date} UTC`;
}

/** `September`. '' when empty or invalid. */
export function monthNameUTC(iso) {
  const d = parse(iso);
  return d ? MONTHS[d.getUTCMonth()] : '';
}
